import "@/src/timezone";
import { createRoot } from "react-dom/client";
import React from "react";
import Rails from "@rails/ujs";
import { AuthenticationApp } from "@circle-react/apps/AuthenticationApp";
import "stylesheets/third_party.scss";
import "stylesheets/application.scss";

Rails.start();

window.webview = {
  /** @deprecated: This is only used by the old webview */
  isComingFromReactNativeWebview: false,
  isComingFromReactNativeAuthenticatedWebview: false,
  // use this one instead
  isInsideMobileWebview: false,
  electronAPI: {},
  // callback called on Live Stream 'Leave' button click, after api calls are done
  onLeaveLiveStream: null,
  // callback called on Live Stream 'Back to community' button click
  onEndLiveStream: null,
};

(function() {
  // If on production we find that this approach is impacting our load times then we can resort to using
  // Simple JS without react.
  const element = document.getElementById("react-root");
  const props = JSON.parse(element.dataset.props) || {};
  const root = createRoot(element);
  root.render(React.createElement(AuthenticationApp, props));
})();
